/**
 * Upload names end up in CDN URLs that are later stored as user-facing links.
 * Whitespace in them makes the URL invalid, so every run of whitespace becomes `-`.
 * The extension, non-ASCII characters and `/` (folder paths) are kept.
 */
export function sanitizeUploadFilename(name: string): string {
  const sanitized = (name ?? '').trim().replace(/\s+/g, '-');
  return sanitized || 'file';
}
